import { useTranslation } from 'react-i18next';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const FormTabs = ({ tabValue, onChange }) => {
  const { t } = useTranslation("flowDesigner");

  return (
    <Tabs
      value={tabValue}
      variant="fullWidth"
      orientation="horizontal"
      onChange={onChange}
      sx={{ minHeight: "40px" }}
    >
      <Tab label={t("common.parameters")} />
      <Tab label={t("common.settings")} />
      <Tab label={t("common.comments")} />
    </Tabs>
  );
};

export default FormTabs;
